import React, { useEffect } from 'react';
import { Box } from '@semcore/ui/flex-box';

import { DESKTOP_MIN_WIDTH } from '@authFlow/App/variables';

import { initUnicornScene, initUnicornSdk } from './helpers';
import styles from './styles.scss';

const ANIMATION_ID = 'unicorn-aurora';

export const AuroraAnimation = () => {
  useEffect(() => {
    const reduceMotionMq = window.matchMedia(
      '(prefers-reduced-motion: reduce)',
    );
    const desktopMq = window.matchMedia(DESKTOP_MIN_WIDTH);
    let running = false;

    const start = () => {
      if (running || reduceMotionMq.matches || !desktopMq.matches) return;
      initUnicornSdk(() => initUnicornScene(ANIMATION_ID));
      running = true;
    };

    const stop = () => {
      if (window.UnicornStudio) {
        window.UnicornStudio.destroy();
      }
      running = false;
    };

    const handleReduceMotion = (e: MediaQueryListEvent) => {
      if (e.matches) {
        stop();
      } else if (desktopMq.matches) {
        start();
      }
    };

    const handleDesktop = (e: MediaQueryListEvent) => {
      if (e.matches && !reduceMotionMq.matches) {
        start();
      } else {
        stop();
      }
    };

    if (!reduceMotionMq.matches && desktopMq.matches) {
      start();
    }

    reduceMotionMq.addEventListener('change', handleReduceMotion);
    desktopMq.addEventListener('change', handleDesktop);

    return () => {
      reduceMotionMq.removeEventListener('change', handleReduceMotion);
      desktopMq.removeEventListener('change', handleDesktop);
      stop();
    };
  }, []);

  return (
    <Box className={styles.container} id={ANIMATION_ID} data-ready={false} />
  );
};
